<template>
  <ul
    class="slider__media__list"
    :class="{ 'slider__media__list--transitions': showTransitions }"
    :style="`--dotcom-app-screens-index: ${currentIndex}`"
    @transitionend="$emit('transitionend', $event)"
  >
    <li
      v-for="(slide, index) in slides"
      :key="index"
      ref="slide"
      class="slider__media__item"
    >
      <img
        v-if="slide.type === 'img'"
        class="slider__media__image"
        :src="slide.srcImage"
        alt=""
      />

      <video
        v-if="slide.type === 'video'"
        class="slider__media__video"
        autoplay
        loop
        muted
      >
        <source :src="slide.srcWebm" type="video/webm" />
        <source :src="slide.srcMp4" type="video/mp4" />

        <p v-if="videoFallbackText">
          <a :href="slide.srcMp4 || slide.srcWebm">{{ videoFallbackText }}</a>
        </p>
      </video>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DotcomSliderMedia',
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    videoFallbackText: {
      type: String,
      default: null,
    },
    showTransitions: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['transitionend'],
  watch: {
    currentIndex(next, last) {
      if (this.slides[next]?.type === 'video') {
        let video = this.$refs.slide[next].querySelector('video')
        video.play()
      }

      if (this.slides[last]?.type === 'video') {
        let video = this.$refs.slide[last].querySelector('video')
        video.pause()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.slider__media {
  &__list {
    display: flex;
    list-style: none;
    height: 100%;

    transform: translateX(
      calc(
        var(--dotcom-app-screens-mask-width) * var(--dotcom-app-screens-index) *
          -1
      )
    );

    &--transitions {
      transition: transform var(--dotcom-app-screens-transition-duration) ease;
    }
  }

  &__item {
    width: var(--dotcom-app-screens-mask-width);
    height: 100%;
    flex-shrink: 0;
    flex-grow: 0;
  }

  &__image,
  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
